import {
  DurationUnit,
  ExpiryRuleType,
  MicrobiologicalLimitation,
  StabilityRuleSource,
  StabilityStage,
} from '@cypro/engine/database/schema'
import {AddStabilityRuleSchema} from '@cypro/engine/mutators'
import * as z from 'zod'

export const StabilityRuleFormSchema = AddStabilityRuleSchema.omit({
  stabilityStage: true,
  storageLabelId: true,
  durationUnit: true,
  expiryRuleType: true,
  microbiologicalLimitation: true,
  containerTypeId: true,
  carrierDrugId: true,
  additionalActiveSubstanceDrugId: true,
}).extend({
  stabilityStage: z.array(StabilityStage).nonempty(),
  storageLabelId: z.array(z.uuidv7()).nonempty(),
  storageLabelName: z.string().optional(),
  durationUnit: z.array(DurationUnit).nonempty(),
  expiryRuleType: z.array(ExpiryRuleType).nonempty(),
  microbiologicalLimitation: z.array(MicrobiologicalLimitation),
  containerTypeId: z.array(z.uuidv7()),
  carrierDrugId: z.array(z.uuidv7()),
  additionalActiveSubstanceDrugId: z.array(z.uuidv7()),
  source: StabilityRuleSource.optional(),
})

export type StabilityRuleFormSchema = z.infer<typeof StabilityRuleFormSchema>
